import { GenericSuccessScreen } from '@/components/shared/GenericSuccessScreen/GenericSuccessScreen';
import { Button } from '@/components/ui/Button/Button';
import { paths } from '@/config/paths';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

export const SuccessStep = () => {
  const { t } = useTranslation('auth', { keyPrefix: 'forgotUsername.steps.success' });

  return (
    <GenericSuccessScreen
      title={t('title')}
      description={t('description')}
      illustration='sphere'
      rightActionElement={
        <Button asChild>
          <Link to={paths.auth.login.path}>{t('button.label')}</Link>
        </Button>
      }
    />
  );
};
